import ReactGA from 'react-ga';
ReactGA.initialize('UA-52890177-3');
// import React from 'react'

exports.onRouteUpdate = (state, page, pages) => {
  ReactGA.pageview(state.pathname);
};

// exports.wrapRootComponent = (Root) => {

//   const cookie = new Cookies();

//   if (cookie.get("locale") === undefined) {
//     const locale = browserLocale() || "en";
//     cookie.set("locale", locale)
//   }

//   const Wrapper = () => (
//     <Root />
//   )
//   return Wrapper;
// }



// WEBPACK FOOTER //
// ../gatsby-browser.js